<template>
  <a-modal
    title="创建二级项目"
    :width="700"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="二级项目名称" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入二级项目名称' }] }]" placeholder="请输入"/>
      </a-form-item>
      <a-form-item label="项目地址" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-cascader
          placeholder="请选择省/市/区"
          :options="areaOptions"
          v-decorator="['province', {
            rules: [{ required: true, message: '请选择项目地址' }],
            initialValue: []
          }]"
        />
      </a-form-item>
      <a-form-item label="关联配置" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-select v-if="configList.length > 0" v-decorator="['configId', { rules: [{ required: true, message: '请选择关联配置' }] }]" placeholder="请选择">
          <a-select-option v-for="config in configList" :key="config.id" :value="config.id">{{ config.name }}</a-select-option>
        </a-select>
        <div v-else class="no-config">
          暂无配置，请前往
          <a href="javascript:void(0)" @click="goToConfigManage">配置管理</a>
          处添加
        </div>
      </a-form-item>
      <a-form-item label="授权数量" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 17 }">
        <a-input-number v-decorator="['max', { rules: [{ required: true, message: '请输入授权数量' }] }]" placeholder="请输入" :min="1"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { areaOptions, getAreaName } from '@/utils/area'
import { getConfigManageDropdown } from '@/api/configManage'
import { createProjectSecondItem, updateProjectSecondItem } from '@/api/projectItem'
export default {
  name: 'SubProjectModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    firstId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      subProject: null,
      areaOptions: areaOptions,
      configList: []
    }
  },
  watch: {
    visible: {
      handler (newVal) {
        if (newVal) {
          this.loadConfigList()
        }
      },
      immediate: false
    }
  },
  methods: {
    loadConfigList () {
      return new Promise((resolve, reject) => {
        getConfigManageDropdown().then(res => {
          if (res.code === 1 && res.data) {
            this.configList = res.data || []
          } else {
            this.configList = []
          }
          console.log(this.configList)
          resolve()
        }).catch(() => {
          this.configList = []
          console.log(this.configList)
          resolve()
        })
      })
    },
    goToConfigManage () {
      this.$emit('goToConfigManage')
    },
    load (subProject) {
      this.subProject = subProject
      console.log(subProject)
      // 检查 configList 是否已加载，如果没有，等待加载完成后再设置值
      if (this.configList.length === 0) {
        // 重新加载配置列表
        this.loadConfigList().then(() => {
          this.setFormValues(subProject)
        })
      } else {
        // 直接设置值
        this.setFormValues(subProject)
      }
    },
    setFormValues (subProject) {
      this.form.setFieldsValue({
        name: subProject.name,
        province: subProject.province.split('/'),
        configId: subProject.configId,
        max: subProject.max || 0
      })
    },
    handleOk () {
      this.confirmLoading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          values.province = values.province.join('/')
          values.provinceCH = getAreaName(values.province)
          values.firstId = this.firstId
          if (this.subProject) {
            values.id = this.subProject.id
            updateProjectSecondItem(values).then(res => {
              if (res.code === 1) {
                this.$message.success('更新二级项目成功')
                this.$emit('ok', values)
              } else {
                this.$message.error(res.msg || '更新二级项目失败')
              }
              this.confirmLoading = false
              this.handleCancel()
            }).catch(() => {
              this.confirmLoading = false
            })
          } else {
            createProjectSecondItem(values).then(res => {
              if (res.code === 1) {
                this.$message.success('创建二级项目成功')
                this.$emit('ok', values)
              } else {
                this.$message.error(res.msg || '创建二级项目失败')
              }
              this.confirmLoading = false
              this.handleCancel()
            }).catch(() => {
              this.confirmLoading = false
            })
          }
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleCancel () {
      this.form.resetFields()
      this.subProject = null
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.no-config {
  color: #999;
  line-height: 32px;
}
.no-config a {
  color: #1890ff;
  text-decoration: none;
  margin: 0 4px;
}
.no-config a:hover {
  text-decoration: underline;
}
</style>
